<app-page-container tableCopy [dropdowns]="dropdowns" [tables]="[termsTable, mappingsTable]">
  <div class="card-body p-0">
    <div class="d-flex first-main">
      <div class="first-section-main-body">
        <span class="default-pointer header-info" title="View server metadata" id="metadataInfo" (click)="openModal(null, 'metadata')">
          <i class="fa-solid fa-circle-info link-color"></i>
        </span>
        <span class="title-font m-0">AutomapAI Review Tool / <a [href]="['batch']" class="link-color default-pointer">Batch Map Set</a></span>
        <p class="table-body-font">
          Review results of normalization process, submit new tasks for testing, and reconcile results that were mapped incompletely or provisionally
        </p>
        <div class="d-flex">
          <a target="_blank" title="WCI AutomapAI API" [href]="apiLink" class="link-color default-pointer d-flex api-link align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--primary-color)">
              <path
                d="m384-336 56-58-86-86 86-86-56-58-144 144 144 144Zm192 0 144-144-144-144-56 58 86 86-86 86 56 58ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm280-590q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790ZM200-200v-560 560Z"
              />
            </svg>
            API</a
          >
        </div>
      </div>
    </div>
  </div>

  <div class="search-box">
    <div class="d-flex justify-content-between">
      <div class="d-flex justify-content-start">
        <app-input [for]="'searchFC'" [placeholder]="'Search Terms'" type="search" [control]="searchFC" (keydown.enter)="search()"></app-input>
        <div class="total-count" title="Total">({{ totalTerms }} Term<span *ngIf="totalTerms !== 1">s</span>)</div>
      </div>
    </div>
    <div class="d-flex btn-row-container">
      <div class="btn-label-container flex-wrap">
        <ng-container *ngFor="let filter of filters">
          <button
            type="button"
            class="btn btn-label mr-2"
            [class.active]="filter.selected"
            (click)="toggleFilter(filter.value)"
            title="Find: {{ filter.label }}"
            id="{{ 'labelBtn_' + filter.value }}"
          >
            {{ filter.label }}
          </button>
        </ng-container>
      </div>

      <button
        type="button"
        title="New Task"
        class="btn-success custom-green-btn modal-button-green"
        (click)="openModal(null, 'new task')"
        id="newTaskBtn"
      >
        New Task
      </button>
    </div>
  </div>

  <div class="card box-shadow mb-3 tablecontainer" #termsTable>
    <div class="row graph-components tablerow">
      <div class="col-md-2 d-flex date-width tablecolumn">
        <span class="light-text default-pointer" (click)="tableSorter('modified')"> Last Modified </span>
        <span class="sort-indicator" *ngIf="sortField === 'modified'" [class]="columnSort['modified'] ? 'transform-180' : 'transform-0'">▾</span>
      </div>
      <div class="col-md-2 d-flex code-width tablecolumn">
        <span class="light-text default-pointer" (click)="tableSorter('code')"> Code </span>
        <span class="sort-indicator" *ngIf="sortField === 'code'" [class]="columnSort['code'] ? 'transform-180' : 'transform-0'">▾</span>
      </div>
      <div class="col-md-2 d-flex tablecolumn">
        <span class="light-text default-pointer" (click)="tableSorter('terminology')"> Terminology </span>
        <span class="sort-indicator" *ngIf="sortField === 'terminology'" [class]="columnSort['terminology'] ? 'transform-180' : 'transform-0'"
          >▾</span
        >
      </div>
      <div class="col-md-3 d-flex tablecolumn">
        <span class="light-text default-pointer" (click)="tableSorter('term')"> Term </span>
        <span class="sort-indicator" *ngIf="sortField === 'term'" [class]="columnSort['term'] ? 'transform-180' : 'transform-0'">▾</span>
      </div>
      <div class="col-md-2 d-flex tablecolumn" title="Entity Type">
        <app-select
          [id]="'sortEntityType'"
          class="header-select header-font"
          [headerSelect]="true"
          [selected]="sortEntityType"
          [noblank]="true"
          [options]="sortEntityTypeOptions"
          (selectedOption)="filterEntityType($event)"
        ></app-select>
      </div>
      <div class="col-md-2 d-flex status-width tablecolumn" title="Status">
        <app-select
          [id]="'sortStatus'"
          class="header-select header-font"
          [headerSelect]="true"
          [selected]="sortStatus"
          [noblank]="true"
          [options]="sortStatusOptions"
          (selectedOption)="filterStatus($event)"
        ></app-select>
      </div>
      <div class="col-md-1 icon-width">
        <div *ngIf="totalTerms > 0" class="default-pointer download-icon" (click)="openDownloadModal()">
          <div *ngIf="tableDownloading === false">
            <i class="fa fa-download" aria-hidden="true" title="Download data"></i>
          </div>
          <div *ngIf="tableDownloading"><i class="fa-solid fa-spinner fa-spin" aria-hidden="true" title="Downloading..."></i></div>
        </div>
      </div>
    </div>
    <div
      *ngFor="let term of allTerms; let i = index"
      class="d-flex graph-components graph-components-body default-pointer tablerow"
      (click)="selectTerm($event, term); currentTerms[i].mouseover = false"
      [class.active]="term?.id === selectedTerm?.id"
      [class.hover]="currentTerms[i].mouseover"
      (mouseover)="term?.id === selectedTerm?.id ? (currentTerms[i].mouseover = false) : (currentTerms[i].mouseover = true)"
      (mouseout)="currentTerms[i].mouseover = false"
    >
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center date-width tablecolumn">
        <span class="default-font text-pointer" title="{{ term?.modified | date: 'MM/dd/yyyy HH:mm:ss' }}">{{
          term?.modified | date: 'MM/dd/yyyy HH:mm:ss'
        }}</span>
      </div>
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center code-width tablecolumn">
        <span class="default-font text-pointer" title="{{ term?.code }}">{{ term?.code }}</span>
      </div>
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center tablecolumn">
        <span class="default-font text-pointer" title="{{ getTerminologyName(term?.terminology) }}">{{ getTerminologyName(term?.terminology) }}</span>
      </div>
      <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 align-self-center tablecolumn">
        <span class="default-font text-pointer" title="{{ term?.term }}">{{ term?.term }}</span>
      </div>
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center tablecolumn">
        <span class="default-font text-pointer" title="{{ term?.entityType }}">{{ term?.entityType }}</span>
      </div>
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center status-width tablecolumn">
        <span class="default-font text-pointer" title="{{ term?.status === 'out_of_scope' ? 'out of scope' : term?.status }}">{{
          term?.status === 'out_of_scope' ? 'out of scope' : term?.status
        }}</span>
      </div>
      <div class="col-xs-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 align-self-center icons-width">
        <span class="default-font default-pointer pr-1 pl-1" title="View task information" id="taskInfo" (click)="openModal(term)">
          <i class="fa-solid fa-circle-info link-color"></i>
        </span>
        <span>
          <a (click)="openModal(term, 'json', 'Term')" class="default-pointer pr-1" title="Show JSON"><i class="fas fa-code link-color"></i></a
        ></span>
        <span class="default-font default-pointer pr-1" title="View audit trail" id="auditInfo" (click)="openModal(term, 'audit')">
          <i class="fa-solid fa-clipboard-check link-color"></i> </span
        ><span class="default-font default-pointer" title="Search term on the web" id="searchTermBtn">
          <a (click)="openLink(term?.searchUrl)" [href]="term?.searchUrl"><i class="fa-solid fa-magnifying-glass link-color"></i></a
        ></span>
        <span *ngIf="isAdmin" class="default-font default-pointer pl-1" title="Remove Term" id="removeTerm" (click)="openModal(term, 'remove term')">
          <i class="fa-regular fa-trash-can link-color"></i>
        </span>
      </div>
    </div>
    <app-not-found *ngIf="allTerms && allTerms.length === 0">No terms found</app-not-found>
    <app-table-pagination
      [page]="page"
      [perPage]="perPage"
      [totalPages]="totalPages"
      [perPageValue]="perPageValue"
      (pageChange)="onPageChange($event)"
      (perPageValueChange)="selectPaginationLimit($event)"
      [collectionSize]="totalPages"
      [restrictAllOption]="true"
    >
    </app-table-pagination>
  </div>
  <div *ngIf="termSelected" [hidden]="allTerms.length === 0" class="card-body p-0">
    <div class="d-flex first-main">
      <div class="first-section-main-body">
        <div class="d-flex justify-content-end header-info">
          <a (click)="openModal(activeMappings, 'json', 'Mappings')" class="default-pointer" title="Show JSON"
            ><i class="fas fa-code link-color"></i
          ></a>
          <span class="default-pointer mr-2" title="View entity type information" id="metadataInfo" (click)="openModal(null, 'metadata type')">
            <i class="fa-solid fa-circle-info link-color"></i>
          </span>
        </div>
        <span *ngIf="!mapGroup" class="title-font m-0">Mappings for "{{ selectedTerm?.term }}"</span>
        <span *ngIf="mapGroup" class="title-font m-0">
          <span>Mappings for "{{ selectedTerm?.term.substring(0, mapping.startIndex) }}</span>
          <span class="highlight">{{ selectedTerm?.term.substring(mapping.startIndex, mapping.endIndex) }}</span>
          <span>{{ selectedTerm?.term.substring(mapping.endIndex) }}"</span>
        </span>

        <p *ngIf="selectedTerm?.status !== 'final' && selectedTerm?.status !== 'out_of_scope'" class="table-body-font">{{ instructions }}</p>
        <p *ngIf="selectedTerm?.status === 'final' || selectedTerm?.status == 'out_of_scope'" class="table-body-font">{{ editInstructions }}</p>
      </div>
    </div>
  </div>

  <div *ngIf="termSelected" [hidden]="allTerms.length === 0" class="search-box">
    <div class="d-flex justify-content-between">
      <div class="d-flex justify-content-start">
        <app-input
          [for]="'searchMap'"
          [placeholder]="'Search Mappings'"
          type="search"
          [control]="searchMap"
          (keydown.enter)="searchMapBox()"
        ></app-input>
        <div class="total-count" title="Total">({{ totalPagesMap }} Mapping<span *ngIf="totalPagesMap !== 1">s</span>)</div>
        <div class="total-count"><span class="bold">Status </span>{{ selectedTerm?.status }}</div>
      </div>
      <span style="margin-left: auto; margin-right: 1%">
        <button
          *ngIf="selectedTerm?.status !== 'final' && selectedTerm?.status !== 'out_of_scope'"
          type="button"
          title="Out Of Scope"
          class="btn-success custom-green-btn modal-button-green mr-3"
          (click)="patchStatus(true)"
          id="outOfScopeBtn"
        >
          Out Of Scope
        </button>
        <button
          *ngIf="selectedTerm?.status !== 'final'"
          type="button"
          title="Cancel"
          class="btn-success custom-green-btn modal-button-green"
          (click)="cancelChange()"
          id="cancelChangeBtn"
        >
          Cancel
        </button></span
      >
      <button
        type="button"
        title="{{ selectedTerm?.status === 'final' || selectedTerm?.status === 'out_of_scope' ? 'Edit Mapping' : 'Finish' }}"
        class="btn-success custom-green-btn modal-button-green"
        (click)="selectedTerm?.status === 'final' || selectedTerm?.status === 'out_of_scope' ? patchStatus() : validateMappings()"
        id="changeStatusBtn"
        [disabled]="selectedTerm?.status !== 'final' && selectedMappings.length <= 0 && selectedTerm?.status !== 'out_of_scope'"
      >
        {{ selectedTerm?.status === 'final' || selectedTerm?.status === 'out_of_scope' ? 'Edit Mapping' : 'Finish' }}
      </button>
    </div>
  </div>

  <div [hidden]="allTerms.length === 0 || !termSelected" class="card box-shadow tablecontainer" #mappingsTable>
    <div class="row graph-components tablerow">
      <div
        *ngIf="allMappingsGrouped"
        class="group-pills group-header align-items-center d-flex sp default-pointer tablecolumn"
        (click)="mappingSorter('startIndex')"
      >
        <span class="light-text"> Group </span>
        <span class="sort-indicator" *ngIf="mappingField === 'startIndex'" [class]="mappingCol['startIndex'] ? 'transform-180' : 'transform-0'"
          >▾</span
        >
      </div>
      <div class="col-md-2 d-flex default-pointer tablecolumn" (click)="mappingSorter('terminology')">
        <span class="light-text"> Terminology </span>
        <span class="sort-indicator" *ngIf="mappingField === 'terminology'" [class]="mappingCol['terminology'] ? 'transform-180' : 'transform-0'"
          >▾</span
        >
      </div>
      <div class="col-md-2 d-flex default-pointer tablecolumn" (click)="mappingSorter('code')">
        <span class="light-text"> Code </span>
        <span class="sort-indicator" *ngIf="mappingField === 'code'" [class]="mappingCol['code'] ? 'transform-180' : 'transform-0'">▾</span>
      </div>
      <div class="col-md-4 d-flex default-pointer tablecolumn" (click)="mappingSorter('name')">
        <span class="light-text"> Name </span>
        <span class="sort-indicator" *ngIf="mappingField === 'name'" [class]="mappingCol['name'] ? 'transform-180' : 'transform-0'">▾</span>
      </div>
      <div class="col-md-2 d-flex code-width default-pointer tablecolumn" (click)="mappingSorter('entityType')">
        <span class="light-text">Entity Type</span>
        <span class="sort-indicator" *ngIf="mappingField === 'entityType'" [class]="mappingCol['entityType'] ? 'transform-180' : 'transform-0'"
          >▾</span
        >
      </div>
      <div class="col-md-2 d-flex status-width default-pointer tablecolumn">
        <span class="light-text" (click)="mappingSorter('confidence')"> Confidence </span>
        <span class="sort-indicator" *ngIf="mappingField === 'confidence'" [class]="mappingCol['confidence'] ? 'transform-180' : 'transform-0'"
          >▾</span
        >
      </div>
      <div class="col-md-1 icon-width"></div>
    </div>
    <div
      *ngFor="let mapping of activeMappings; let j = index"
      class="d-flex graph-components graph-components-body tablerow"
      [class.default-pointer]="selectedTerm?.status !== 'final' && selectedTerm?.status !== 'out_of_scope'"
      [class.inactive]="selectedTerm?.status === 'final' || selectedTerm?.status == 'out_of_scope'"
      [class.active]="selectedTerm?.status !== 'final' && selectedTerm?.status !== 'out_of_scope' && mapping.selected"
      [class.hover]="currentActiveMappings[j].mouseover"
      (mouseover)="showMappingGroup(mapping); currentActiveMappings[j].mouseover = true"
      (mouseout)="clearMappingGroup(); currentActiveMappings[j].mouseover = false; mapGroup = ''"
      (dblclick)="selectedTerm?.status !== 'final' && selectedTerm?.status !== 'out_of_scope' ? selectMapping(mapping) : null"
    >
      <div *ngIf="allMappingsGrouped" class="group-pills nav-pills p-0 pill-label tablecolumn">
        <ul
          *ngIf="
            mapping.startIndex > 0 || mapping.endIndex - mapping.startIndex !== mapping.term?.length || mapping.term?.length !== mapping.name?.length
          "
          class="nav nav-pills"
        >
          <li class="nav-item nobreak">
            <a class="nav-link active default-pointer" title="{{ mapping.term }}">{{ mapping.startIndex + '-' + mapping.endIndex }}</a>
          </li>
        </ul>
        <ul
          *ngIf="
            mapping.startIndex === 0 &&
            mapping.endIndex - mapping.startIndex === mapping.term?.length &&
            mapping.term?.length === mapping.name?.length
          "
        >
          <li class="no-list-style"></li>
        </ul>
      </div>
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center tablecolumn">
        <span class="default-font ellipsis line-clamp-1" title="{{ getTerminologyName(mapping?.terminology) }}">{{
          getTerminologyName(mapping?.terminology)
        }}</span>
      </div>
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center tablecolumn">
        <span class="default-font" title="{{ mapping?.code }}">{{ mapping?.code }}</span>
      </div>

      <a class="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 align-self-center tablecolumn">
        <div class="d-flex align-items-center">
          <span class="default-font" title="{{ mapping?.name }}">{{ mapping?.name }}</span>
        </div>
      </a>
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center code-width tablecolumn">
        <span class="default-font" title="{{ mapping?.entityType }}">{{ mapping?.entityType }}</span>
      </div>
      <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center status-width tablecolumn">
        <span class="default-font" title="{{ getConfidence(mapping?.confidence) }}">{{ getConfidence(mapping?.confidence) }}</span>
      </div>
      <div class="col-xs-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 align-self-center icon-width">
        <span>
          <a (click)="openModal(mapping, 'json', 'Mapping')" class="default-pointer" title="Show JSON"><i class="fas fa-code link-color"></i></a
        ></span>
      </div>
      <div *ngIf="selectedTerm?.status !== 'final'" class="col-xs-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 align-self-center check-width">
        <span *ngIf="mapping.selected" class="default-font default-pointer" title="Selected Mapping" id="mapCheck">
          <i class="fa-solid fa-check blue-check"></i>
        </span>
      </div>
    </div>
    <app-not-found *ngIf="allMappings && allMappings.length === 0">No mappings found</app-not-found>
    <app-table-pagination
      [page]="mappingPage"
      [perPage]="mappingPerPage"
      [totalPages]="totalPagesMap"
      [perPageValue]="perPageValMap"
      (pageChange)="onPageChangeMap($event)"
      (perPageValueChange)="selectPaginationLimitMap($event)"
      [collectionSize]="totalPagesMap"
      [restrictAllOption]="false"
      [xlargeLimitOptions]="true"
    >
    </app-table-pagination>
  </div>

  <ng-template #metadataModal let-modal>
    <div tableCopy [tables]="[confTable]">
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">Metadata Information</span>
          <div class="justify-content-end" (click)="modal.close('Cancel')">
            <span class="fas fa-times btn-close default-pointer" title="Close" aria-label="Close"></span>
          </div>
        </div>
        <div class="modal-body modal-scroll">
          <div *ngFor="let data of metadata | keyvalue; let i = index">
            <span class="total-count"> {{ data.key.toString().replaceAll('.', ' ') | titlecase }}</span>
            <ul>
              <div *ngFor="let list of data.value | keyvalue; let i = index">
                <li class="list-style">
                  <span class="bold mr-2"> {{ list.key.toString().replaceAll('.', ' ').replaceAll('_', ' ') }}</span> {{ list.value }}
                </li>
              </div>
            </ul>
          </div>
          <span class="total-count">Entity Config</span>
          <div [hidden]="!showEntityConfigTable" #entityConfigTable class="tablecontainer">
            <div class="row graph-components tablerow">
              <div class="col-2 d-flex tablecolumn">
                <span class="light-text">Entity type</span>
              </div>
              <div class="col-2 d-flex tablecolumn">
                <span class="light-text">Terminology</span>
              </div>
              <div class="col-2 d-flex tablecolumn">
                <span class="light-text">Active Only</span>
              </div>
              <div class="col-5 d-flex tablecolumn">
                <span class="light-text">Scope</span>
              </div>
              <div class="col-1 d-flex icon-width">
                <a (click)="showEntityConfigTable = false" class="default-pointer pr-2" title="Show JSON"><i class="fas fa-code link-color"></i></a>
              </div>
            </div>
            <div *ngFor="let entity of entityConfig; let e = index" class="d-flex graph-components graph-components-body tablerow">
              <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center tablecolumn">
                <span class="default-font" title="{{ entity?.entityType }}">{{ entity?.entityType }}</span>
              </div>
              <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center tablecolumn">
                <span class="default-font" title="{{ entity?.terminology }}">{{ entity?.terminology }}</span>
              </div>
              <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2 align-self-center tablecolumn">
                <span class="default-font" title="{{ entity?.activeOnly }}">{{ entity?.activeOnly }}</span>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 align-self-center tablecolumn">
                <span class="default-font" title="{{ entity?.scope }}">{{ entity?.scope }}</span>
              </div>
            </div>
          </div>
          <div *ngIf="!showEntityConfigTable">
            <div class="row graph-components">
              <div class="col-11 d-flex">
                <span class="light-text">JSON</span>
              </div>
              <div class="col-1 d-flex">
                <a (click)="showEntityConfigTable = true" class="default-pointer" title="Show Table"><i class="fa-solid fa-table link-color"></i></a>
              </div>
            </div>
            <div class="d-flex graph-components graph-components-body">
              <pre><code>{{ getJSON(entityConfig) }}</code></pre>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" title="Cancel" class="btn-success custom-green-btn modal-button-green" (click)="modal.close('Cancel')" id="closeBtn">
            Close
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #metadataTypeModal let-modal>
    <div>
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">Entity Type</span>
          <div class="justify-content-end" (click)="modal.close('Cancel')">
            <span class="fas fa-times btn-close default-pointer" title="Close" aria-label="Close"></span>
          </div>
        </div>
        <div class="modal-body">
          <span class="total-count bold"> {{ selectedTerm.entityType }}</span>
          <span class="default-font"> {{ metadata['term.entityType'][selectedTerm.entityType] }}</span>
        </div>
        <div class="modal-footer">
          <button type="button" title="Cancel" class="btn-success custom-green-btn modal-button-green" (click)="modal.close('Cancel')" id="closeBtn">
            Close
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #taskModal let-modal>
    <div>
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">Task Details</span>
          <div class="justify-content-end">
            <span>
              <a (click)="openModal(taskDetails, 'json', 'Task')" class="default-pointer pr-1" title="Show JSON"
                ><i class="fas fa-code link-color"></i></a
            ></span>
            <span class="default-pointer btn-close" title="Close" aria-label="Close" (click)="modal.close('Cancel')">
              <i class="fas fa-times"></i>
            </span>
          </div>
        </div>
        <div class="modal-body">
          <ul style="margin-bottom: 0; padding-right: 40px">
            <li class="list-style"><span class="bold">Created</span> {{ taskDetails?.created | date: 'MM/dd/yyyy HH:mm:ss' }}</li>
            <li class="list-style"><span class="bold">Request Source</span> {{ taskDetails?.requestSource }}</li>
            <li class="list-style"><span class="bold">Request Timestamp</span> {{ taskDetails?.requestTimestamp | date: 'MM/dd/yyyy HH:mm:ss' }}</li>
            <li class="list-style"><span class="bold">Top Answer</span> {{ taskDetails?.topAnswer }}</li>
            <li class="list-style"><span class="bold">Minimum Confidence</span> {{ taskDetails?.minConfidence }}</li>
            <li class="list-style"><span class="bold">Tags</span> {{ mapTags(taskDetails) }}</li>
            <li class="list-style"><span class="bold">Term Count</span> {{ taskDetails?.terms?.length }}</li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" title="Cancel" class="btn-success custom-green-btn modal-button-green" (click)="modal.close('Cancel')" id="closeBtn">
            Close
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #auditModal let-modal>
    <div>
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">Audit Trail</span>
          <div class="justify-content-end" (click)="modal.close('Cancel')">
            <span class="fas fa-times btn-close default-pointer" title="Close" aria-label="Close"></span>
          </div>
        </div>
        <div class="modal-body">
          <div *ngFor="let arr of auditDetails; let i = index" class="audit-body">
            <div [style.color]="arr?.error ? 'red' : 'black'">
              {{ arr?.created | date: 'MM/dd/yyyy HH:mm:ss' }} {{ arr?.message }}
              <div *ngFor="let key of arr?.details | keyvalue">&nbsp;&nbsp;&nbsp;&nbsp;{{ key.key }} = {{ key.value }}</div>
            </div>
          </div>
          <span *ngIf="auditDetails?.length == 0">Audit trail not recorded</span>
        </div>

        <div class="modal-footer">
          <button type="button" title="Cancel" class="btn-success custom-green-btn modal-button-green" (click)="modal.close('Cancel')" id="closeBtn">
            Close
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #newTaskModal let-modal>
    <div>
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">New Task</span>
          <div class="justify-content-end" (click)="closeSubmitModal(modal)">
            <span class="fas fa-times btn-close default-pointer" title="Close" aria-label="Close"></span>
          </div>
        </div>
        <div *ngIf="notSubmitted" class="modal-body">
          <app-input
            label="Term / FHIR Resource text"
            type="text"
            placeholder='Enter new term, e.g. "diabetes"'
            [control]="newTerm"
            [required]="true"
            (keydown.enter)="submitNew(modal)"
            (paste)="handlePaste($event)"
          ></app-input>
          <div *ngIf="isFhirTerm && fhirTermError !== ''" class="invalid-margin is-invalid">{{ fhirTermError }}</div>
          <app-input
            *ngIf="!isFhirTerm"
            label="Terminology"
            type="text"
            placeholder="Enter terminology"
            [control]="newTerminology"
            [required]="false"
            (keydown.enter)="submitNew(modal)"
          ></app-input>
          <app-input
            *ngIf="!isFhirTerm"
            label="Code"
            type="text"
            placeholder="Enter code"
            [control]="newCode"
            [required]="false"
            (keydown.enter)="submitNew(modal)"
          ></app-input>
          <app-select
            *ngIf="!isFhirTerm"
            [id]="'selectEntityType'"
            [label]="'Entity Type'"
            [selected]="selectedEntityType"
            [placeholder]="'Select entity type'"
            [options]="entityTypeOptions"
            [required]="true"
            (selectedOption)="selectOption($event, 'selectedEntityType')"
          ></app-select>
          <app-input
            label="Minimum Confidence"
            type="text"
            placeholder="Enter minimum confidence"
            [control]="newConfidence"
            [required]="true"
            (input)="keycheck($event)"
            (keypress)="keycheck($event)"
            (focusout)="validateNumberInput()"
            (keydown.enter)="submitNew(modal)"
          ></app-input>
        </div>
        <div class="modal-footer">
          <div *ngIf="notSubmitted">
            <button
              type="button"
              title="Submit"
              class="btn-success custom-green-btn modal-button-green"
              (click)="submitNew(modal)"
              id="closeBtn"
              [class]="newTerm.value.length === 0 ? 'disabled' : 'btn-success'"
              [disabled]="newTerm.value.length === 0"
            >
              Submit</button
            >&nbsp;&nbsp;
            <button type="button" title="Cancel" class="btn-font btn-default-font default-pointer" (click)="closeSubmitModal(modal)" id="closeBtn">
              Cancel
            </button>
          </div>
          <div *ngIf="!notSubmitted" style="text-align: center">
            <p class="table-body-font">Task successfully submitted.</p>
            <button
              type="button"
              title="Reload Terms"
              class="btn-success custom-green-btn modal-button-green"
              (click)="reloadTerms(modal)"
              id="closeBtn"
            >
              Reload Terms
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #mapErrModal let-modal>
    <div>
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">Error updating term</span>
          <div class="justify-content-end" (click)="modal.close('Cancel')">
            <span class="fas fa-times btn-close default-pointer" title="Close" aria-label="Close"></span>
          </div>
        </div>
        <div class="modal-body">
          {{ modalErrMessage }}
        </div>
        <div class="modal-footer">
          <button type="button" title="Cancel" class="btn-success custom-green-btn modal-button-green" (click)="modal.close('Cancel')" id="closeBtn">
            Close
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #jsonModal let-modal>
    <div>
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">{{ modalTitle }}</span>
          <div class="justify-content-end" (click)="modal.close('Cancel')">
            <span class="fas fa-times btn-close default-pointer" title="Close" aria-label="Close"></span>
          </div>
        </div>
        <div class="modal-body modal-scroll">
          <pre><code>{{ modalContent }}</code></pre>
        </div>
        <div class="modal-footer">
          <button type="button" title="Cancel" class="btn-success custom-green-btn modal-button-green" (click)="modal.close('Cancel')" id="closeBtn">
            Close
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #DownloadModal let-modal>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">Download Search Results</span>
          <div class="justify-content-end" (click)="modal.close('Cancel')">
            <span class="fas fa-times btn-close default-pointer" title="Close" aria-label="Close"></span>
          </div>
        </div>
        <div class="modal-body">
          <div>
            <p>{{ downloadSearchMessage }}</p>
            <span class="modal-note" *ngIf="totalTerms > 5000">NOTE: The data files may be large.</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-success custom-green-btn modal-button-green"
            (click)="modal.close('Download')"
            title="Download"
            id="downloadBtn"
          >
            Download
          </button>
          <button type="button" class="btn-font btn-default-font" (click)="modal.close('Cancel')" title="Cancel" id="cancelBtn">Cancel</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #removeTermModal let-modal>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header d-flex">
          <span class="user-title-font">Confirm Remove Term</span>
          <div class="justify-content-end" (click)="modal.close('Cancel')">
            <span class="fas fa-times btn-close default-pointer" title="Close" aria-label="Close"></span>
          </div>
        </div>
        <div class="modal-body">
          <div>
            <p>Are you sure you want to remove this term?</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn-success custom-green-btn modal-button-green" (click)="modal.close('Cancel')" title="Cancel" id="cancelBtn">
            No, Cancel
          </button>
          <button type="button" class="modal-button-alert" (click)="removeTermConfirm(); modal.close('Cancel')" title="Remove" id="removeBtn">
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</app-page-container>
